// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__WiUR2","info":"UpdateTermsInfo_info__22Me5"};